interface IsPaidAdCampaignParams {
  utm_medium: Maybe<string>
  utm_source: Maybe<string>
}

export const isPaidAdCampaign = ({ utm_medium, utm_source }: IsPaidAdCampaignParams) => {
  const source = utm_source ?? ''
  const medium = utm_medium ?? ''

  const isPaidMetaCampaign = medium === 'paid' && ['facebook', 'meta', 'instagram'].includes(source)
  const isOrganicInstagram = medium === 'organic' && source === 'instagram'
  const isGoogleCampaign = ['cpc', 'ppc', 'paid'].includes(medium) && ['google', 'adwords'].includes(source)

  return isPaidMetaCampaign || isOrganicInstagram || isGoogleCampaign
}
